import React from 'react';
import StudentsNavbar from "../../Components/Navbars/StudentsNavbar";
import Vacancy from './Vacancy'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';
import { ReplyButton } from '../../Components/ReplyButton';
import { Vacancy as VacancyType } from '../../types';

let vacancyId: string;
export const VacancyStudent = () => {
    const { getVacancyById, reactToVacancy } = usePortalService();

    const params = useParams();
    vacancyId = params.id as string;
    const [vacancy, setVacancy] = useState<VacancyType>();
    const [error, setError] = useState();

    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        setIsLoading(true);
        getVacancyById(vacancyId)  
        .then(result => {
            if (result.success){
                setVacancy(result.vacancy)
                setIsLoading(false);
            } else {
                setError(result.errors)
            }
        });
    }, []);

    return (
        <>
            <StudentsNavbar/>
            <Vacancy vacancy={vacancy as VacancyType} userRole={"profile"} isLoading={isLoading}>
                {(vacancy && vacancy.status !== "В архиве") && 
                    <ReplyButton 
                        style={{width:'173px', marginBottom:'32px'}} 
                        vacancyId={vacancy.id} 
                        reaction={vacancy.infoAboutReaction}
                    />}
            </Vacancy>
            {error && <p style={{paddingTop:'100px', paddingLeft: '150px'}}> {error} </p>}
        </>
    );
}